import React, { Component } from 'react';

/* eslint-disable react/no-did-mount-set-state */

export default class Notice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      message1: null,
      message2: null,
      date: new Date()
    };

    // special time for friday pm
    this.times = {
      mon: {
        am: new Date('Mon Oct 05 2020 9:00:00 GMT-0400'),
        pm: new Date('Mon Oct 05 2020 17:00:00 GMT-0400')
      },
      tue: {
        am: new Date('Tue Oct 06 2020 9:00:00 GMT-0400'),
        pm: new Date('Tue Oct 06 2020 17:00:00 GMT-0400')
      },
      wed: {
        am: new Date('Wed Oct 07 2020 9:00:00 GMT-0400'),
        pm: new Date('Wed Oct 07 2020 17:00:00 GMT-0400')
      },
      thu: {
        am: new Date('Thu Oct 08 2020 9:00:00 GMT-0400'),
        pm: new Date('Thu Oct 08 2020 17:00:00 GMT-0400')
      },
      fri: {
        am: new Date('Fri Oct 09 2020 9:00:00 GMT-0400'),
        pm: new Date('Fri Oct 09 2020 16:00:00 GMT-0400')
      }
    };

    this.closeNotice = this.closeNotice.bind(this);
  }

  componentDidMount() {
    this.setState({ show: document.cookie.indexOf('fc_notice_closed') === -1 });

    if (
      this.state.date >= this.times.mon.am &&
      this.state.date < this.times.mon.pm
    ) {
      // Monday AM
      this.setState({
        message1: 'Innovation Festival: <b>Watch Today</b>',
        message2: 'LENA WAITHE, ROBERT DOWNEY JR + MORE'
      });
    } else if (
      this.state.date >= this.times.mon.pm &&
      this.state.date < this.times.tue.am
    ) {
      // Monday PM
      this.setState({
        message1: 'Innovation Festival: <b>GET TICKETS NOW</b>',
        message2: 'JANELLE MONÁE, TOMMY HILFIGER + MORE'
      });
    } else if (
      this.state.date >= this.times.tue.am &&
      this.state.date < this.times.tue.pm
    ) {
      // Tuesday AM
      this.setState({
        message1: 'Innovation Festival: <b>Watch Today</b>',
        message2: 'JANELLE MONÁE, TOMMY HILFIGER + MORE'
      });
    } else if (
      this.state.date >= this.times.tue.pm &&
      this.state.date < this.times.wed.am
    ) {
      // Tuesday PM
      this.setState({
        message1: 'Innovation Festival: <b>GET TICKETS NOW</b>',
        message2: 'CHIP AND JOANNA GAINES + MORE'
      });
    } else if (
      this.state.date >= this.times.wed.am &&
      this.state.date < this.times.wed.pm
    ) {
      // Wednesday AM
      this.setState({
        message1: 'Innovation Festival: <b>Watch Today</b>',
        message2: 'CHIP AND JOANNA GAINES + MORE'
      });
    } else if (
      this.state.date >= this.times.wed.pm &&
      this.state.date < this.times.thu.am
    ) {
      // Wednesday PM
      this.setState({
        message1: 'Innovation Festival: <b>GET TICKETS NOW</b>',
        message2: 'MICHELLE PFEIFFER, AMY KLOBUCHAR + MORE'
      });
    } else if (
      this.state.date >= this.times.thu.am &&
      this.state.date < this.times.thu.pm
    ) {
      // Thursday AM
      this.setState({
        message1: 'Innovation Festival: <b>Watch Today</b>',
        message2: 'MICHELLE PFEIFFER, AMY KLOBUCHAR + MORE'
      });
    } else if (
      this.state.date >= this.times.thu.pm &&
      this.state.date < this.times.fri.am
    ) {
      // Thursday PM
      this.setState({
        message1: 'Innovation Festival: <b>GET TICKETS NOW</b>',
        message2: 'TRIXIE MATTEL, STEWART BUTTERFIELD + MORE'
      });
    } else if (
      this.state.date >= this.times.fri.am &&
      this.state.date < this.times.fri.pm
    ) {
      // Friday AM
      this.setState({
        message1: 'Innovation Festival: <b>Watch Today</b>',
        message2: 'TRIXIE MATTEL, STEWART BUTTERFIELD + MORE'
      });
    } else if (this.state.date >= this.times.fri.pm) {
      // Friday PM - DON'T DISPLAY
      this.setState({
        show: false
      });
    } else {
      this.setState({
        message1: 'Innovation Festival: <b>GET TICKETS NOW</b>',
        message2: 'October 5 - 9, 2020'
      });
    }

    setInterval(() => {
      if (this.state.show) {
        if (
          document.querySelector('.slide.slide1').classList.contains('show')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('show', 'hide');
          document
            .querySelector('.slide.slide2')
            .classList.replace('hide', 'show');
        } else if (
          document.querySelector('.slide.slide1').classList.contains('hide')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('hide', 'show');
          document
            .querySelector('.slide.slide2')
            .classList.replace('show', 'hide');
        }
      }
    }, 3000);
  }

  closeNotice() {
    document.cookie = 'fc_notice_closed';
    this.setState({ show: false });
  }

  render() {
    if (!this.state.show) {
      return false;
    }

    return (
      <section className="notice">
        <div className="inner">
          <div className="slide slide1 show">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://events.fastcompany.com/innovationfestival20?cid=dan:732:0:_&utm_source=paidDisplayOn&utm_medium=0&utm_campaign=topnav"
              dangerouslySetInnerHTML={{ __html: this.state.message1 }}
            />
          </div>

          <div className="slide slide2 hide">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://events.fastcompany.com/innovationfestival20?cid=dan:732:0:_&utm_source=paidDisplayOn&utm_medium=0&utm_campaign=topnav"
              dangerouslySetInnerHTML={{ __html: this.state.message2 }}
            />
          </div>

          <div
            className="close"
            onClick={() => {
              this.closeNotice();
            }}
          >
            <img
              src="https://images.fastcompany.net/image/upload/v1599849526/fcweb/ex_ndgqh7.svg"
              alt="X"
            />
          </div>
        </div>
      </section>
    );
  }
}
